import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubmissionAgentDropdownTemplate from "@Broker/@HandlebarsTemplates/clients/applications/direct-to-lender/_submission-agent-dropdown.hbs";
import { mapState, mapActions, mapGetters } from "vuex";
import { SAVE_SUBMISSION_AGENT, UPDATE_SUBMISSION_AGENT, ASSIGN_SUBMISSION_AGENT } from "../../../../store/lender-submit-actions";
import * as FieldComponents from "@Shared/components/sections/index";
import SubmissionAgent from "./submission-agent.vue";
import Select2 from "@Shared/components/inputs/select2.vue";
import Err from "../../../../../../../../routes/error";
import WidgetEventsMixin from "@Shared/@Utils/application-mixins/widget-events-mixin";
import { cloneDeep, omit } from "lodash";
import Amplitude from "@Shared/@Utils/amplitude";
import { CURRENT_APPLICATION } from "../../../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SubmissionAgents",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    SubmissionAgent,
    Select2
  }),
  mixins: [WidgetEventsMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedSubmissionAgent: {
        submissionAgentId: null
      },
      editing: false,
      initSelect: false,
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapState("ApplicationStore", {
    submissionAgents(state) {
      return state.participants.submissionAgents.byId;
    },
    submissionAgentsValues() {
      return _Object$values(this.submissionAgents);
    },
    select2Options() {
      if (!this.initSelect) return;
      const formatResult = state => $(SubmissionAgentDropdownTemplate(state));
      const createAsNewSubmissionAgent = this.$t("direct-to-lender.participants.createAsNewSubmissionAgent");
      return {
        templateResult: formatResult,
        dropdownParent: $(this.$refs.submissionAgentSelectContainer),
        closeOnSelect: true,
        placeholder: this.$t("global.words.none"),
        dropdownCssClass: "submission-agent-select",
        language: {
          noResults() {
            const text = $("#submission-agent-select-container .select2-search__field").val();
            return `
              <button class="no-results-btn d-flex flex-column bold" id="no-results-btn"> ${text}
                <span class="grey-text font-italic font-weight-normal" style="pointer-events: none;">
                  ${createAsNewSubmissionAgent}
                </span>
              </button>`;
          }
        },
        escapeMarkup(markup) {
          return markup;
        }
      };
    }
  })), {}, {
    assignedSubmissionAgentId() {
      return this.CURRENT_APPLICATION.submissionAgentId;
    }
  }),
  mounted() {
    this.setCloseWidgetOnExit(false);
    this.$nextTick(() => {
      this.initSelect = true;
      this.$refs.select.initSelect2();
    });
    if (this.assignedSubmissionAgentId) {
      this.setCurrentSelectedSubmissionAgent(this.assignedSubmissionAgentId);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SAVE_SUBMISSION_AGENT, UPDATE_SUBMISSION_AGENT, ASSIGN_SUBMISSION_AGENT])), {}, {
    handleSelect2Click(event) {
      var _context;
      if (_includesInstanceProperty(_context = ["no-results-span", "no-results-btn"]).call(_context, event.target.id)) {
        const text = $("#submission-agent-select-container .select2-search__field").val();
        $("#submission-agent-select").select2("close");
        const [givenName = "", ...familyNames] = text.split(" ");
        const familyName = familyNames.join(" ");
        this.clearSubmissionAgent();
        this.selectedSubmissionAgent = _objectSpread(_objectSpread({}, this.selectedSubmissionAgent), {}, {
          givenName,
          familyName
        });
        this.editing = true;
      }
    },
    formatData(data) {
      var _data$map, _data;
      data = cloneDeep(data);
      return (_data$map = (_data = data) == null ? void 0 : _mapInstanceProperty(_data).call(_data, ref => {
        ref.id = ref.submissionAgentId;
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      })) != null ? _data$map : [];
    },
    handleSelect2Change({
      submissionAgentId
    }, type) {
      switch (type) {
        case "unselect":
          this.clearSubmissionAgent();
          this.assignSubmissionAgentToApplication(null);
          this.editing = false;
          break;
        case "select":
          this.assignSubmissionAgentToApplication(submissionAgentId);
          break;
      }
    },
    setCurrentSelectedSubmissionAgent(submissionAgentId) {
      if (this.submissionAgents[submissionAgentId]) {
        this.selectedSubmissionAgent = cloneDeep(this.submissionAgents[submissionAgentId]);
        this.editing = true;
      }
    },
    async assignSubmissionAgentToApplication(submissionAgentId) {
      this.loading = true;
      try {
        await this.ASSIGN_SUBMISSION_AGENT({
          submissionAgentId,
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
        this.notifyValidationsPage();
        this.setCurrentSelectedSubmissionAgent(submissionAgentId);
      } catch (e) {
        Amplitude.logHandledError(e);
      } finally {
        this.loading = false;
      }
    },
    notifyValidationsPage() {
      this.sendWidgetMessage("validation-rules", "refresh");
    },
    toggleAdd() {
      this.clearSubmissionAgent();
      this.editing = true;
    },
    clearSubmissionAgent() {
      this.selectedSubmissionAgent = {
        address: {
          city: "",
          line1: "",
          line2: "",
          "street-number": "",
          "street-name": "",
          "postal-code": "",
          province: ""
        },
        email: "",
        givenName: "",
        familyName: "",
        middleName: "",
        phoneNumber: "",
        altPhoneNumber: "",
        firmCode: "",
        expertProfileNumber: "",
        submissionAgentId: null,
        licenseRegistrationNumber: ""
      };
    },
    clearSubmissionAgentByButton() {
      this.clearSubmissionAgent();
      this.assignSubmissionAgentToApplication(null);
      this.editing = false;
    },
    async handleAdd(submissionAgent, targetButton) {
      $(targetButton).animateButton().animate("start");
      try {
        const submissionAgentId = await this.SAVE_SUBMISSION_AGENT({
          submissionAgent: omit(submissionAgent, "submissionAgentId")
        });
        this.setCurrentSelectedSubmissionAgent(submissionAgentId);
        this.assignSubmissionAgentToApplication(submissionAgentId);
        $(targetButton).animateButton().animate("finish");
      } catch (e) {
        Err.handle(e, {}, "errorCreatingSubmissionAgent");
        $(targetButton).animateButton().animate("finish", "failed");
      }
    },
    async handleEdit(submissionAgent, targetButton) {
      $(targetButton).animateButton().animate("start");
      try {
        await this.UPDATE_SUBMISSION_AGENT({
          submissionAgent
        });
        this.notifyValidationsPage();
        $(targetButton).animateButton().animate("finish");
      } catch (e) {
        Err.handle(e, {}, "errorEditingSubmissionAgent");
        $(targetButton).animateButton().animate("finish", "failed");
      }
    }
  })
});